var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"login-contents"},[_c('div',{staticClass:"login-contents__sub"},[_vm._v("キャンペーン価格での購入を行うためには、アプリ上でのメールアドレス登録が必要です。登録後に再度このページにアクセスしてください。")]),_vm._v(" "),_c('div',{staticClass:"login-contents__img"},[_c('img',{attrs:{"src":require('../../../static/img/account-create.png'),"alt":"","height":"350"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6989c67c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campainPage/AccountCreate.vue
// module id = 330
// module chunks = 0